import { StyleSheet } from 'aphrodite';
import { titles, grayDark, navigation } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		marginBottom: 16,
	},

	label: {
		display: 'block',
		marginBottom: 8,
		fontSize: 14,
		fontWeight: 600,
		color: titles,
	},

	radioGroup: {
		display: 'flex',
		gap: 16,
		marginBottom: 8,
	},

	radioLabel: {
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
		fontSize: 14,
		color: grayDark,
	},

	radioInput: {
		marginRight: 6,
		cursor: 'pointer',
	},

	radioText: {
		userSelect: 'none',
	},

	note: {
		fontSize: 12,
		color: navigation,
		margin: 0,
		fontStyle: 'italic',
	},
});
